import type { HoqiRedecoWebhook } from '~/shared/schemas/hoqi'
import type { HoqiRequest, HoqiResponse } from '~/shared/types/hoqi'
import { http, HttpResponse } from 'msw'

const hoqiUrl = 'https://api.hoqi.app/api/v1'

export function hoqiRedecoHandler() {
  return http.post<never, HoqiRequest, HoqiResponse>(`${hoqiUrl}/ml/generate/redeco`, async ({ request }) => {
    const body = await request.json()
    setTimeout(hoqiSuccessfulResponse, 4000, body.external_id)
    return HttpResponse.json({
      image_url: body.file_url,
      external_id: body.external_id,
    })
  })
}

// Simule le fait que Hoqi appelle notre webhook une fois la génération d'image terminée
async function hoqiSuccessfulResponse(externalId: string) {
  await $fetch('http://localhost:3000/api/webhooks/hoqi', {
    method: 'POST',
    body: {
      error: false,
      image_url: 'https://images.unsplash.com/photo-1635531340242-e485026e6ad4?q=80&w=1970&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
      image_width: 1080,
      image_height: 720,
      image_lower_width: 0,
      image_lower_height: 0,
      date: '01/01/1960',
      external_id: externalId,
    } satisfies HoqiRedecoWebhook,
  })
}
